/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import NavBar from "../../../components/NavBar/NavBar";
import OrderTabV2 from "./Chunks/OrderTabV2";
import SalesTabV4 from "./Chunks/SalesTabV4";
import SalesTabForOnline from "./Chunks/SalesTabForOnline";
import ChangeStatusDispute from "./Chunks/ChangeStatusDispute";
import ChangeStatusV2 from "./Chunks/ChangeStatusV2";
import { IsEmpty } from "../../../utils/helper";
import {
  HttpRequest,
  HttpRequestFileDownload,
} from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import ChangeContactInfo from "./Chunks/ChangeContactInfo";
import ChangeItemQuantity from "./Chunks/ChangeItemQuantityV2";

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: 70,
    overFlow: "hidden",
  },
  contentContainer: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentContainerS: {
    alignItems: "center",
    textAlign: "center",
    width: "50%",
    marginLeft: 10,
    marginRight: 5,
  },
  contentContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
  },
});

class C10OrderConfirmationDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersData: [],
      ordersDataLoading: false,
      salesDataItems: [],
      salesDataItemsLoading: false,
      salesData: [],
      salesDataLoading: false,
      imagesData: [],
      imagesDataLoading: false,
      barcodeData: [],
      barcodeDataLoading: false,
      selectedOrder: {},
      selectedSalesData: {},
      selectedOrderItemForCopies: {},
      isDownloadImages: false,
      isDownloadPdfImages: false,

      isLoading: false,
      isReload: true,
      productIds: [],

      boqData: [
        {
          id: 1,
          itemLabel: "Premium Hard Page",
          requiredLabel: "30",
          required: 30,
          availableLabel: "1000",
          available: 1000,
        },
        {
          id: 2,
          itemLabel: "Linen Red Color",
          requiredLabel: "50 in",
          required: 50,
          availableLabel: "100 in",
          available: 100,
        },
        {
          id: 3,
          itemLabel: "Card Board",
          requiredLabel: "70 in",
          required: 70,
          availableLabel: "50 in",
          available: 50,
        },
        {
          id: 4,
          itemLabel: "Laymination",
          requiredLabel: "40 in",
          required: 40,
          availableLabel: "150 in",
          available: 150,
        },
      ],

      listOfActivitiesData: [
        { id: 1, label: "Send for Printing" },
        { id: 2, label: "Issue Materials" },
        { id: 3, label: "Arrange Cardboard" },
        { id: 4, label: "Print Barcode" },
        { id: 5, label: "Assign Barcode toa bin" },
      ],

      openChangeStatusDialog: false,
      openChangeContactInfoDialog: false,
      openChangeItemQuantityDialog: false,
      openChangeStatusDisputedDialog: false,
      selectionData: [],
      selectionDataError: "",

      statusData: [],
      statusDataLoading: false,

      // status: "",
      // statusError: "",

      remarks: "",
      remarksError: "",

      customerNameError: "",
      address1Error: "",
      address2Error: "",
      mobileError: "",

      quantityError: "",

      filterStatus: 2,
      filterStatusError: "",

      selectImageObject: {},
      selectImageIndex: 0,
      isOpenImageViewer: false,

      selectedQuantity: 0,
      selectedOrderItemId: 0,

      isNextArrowDisabled: true,
      isBackArrowDisabled: true,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      onConfirmItemStatusLoading: false,
      onCancelItemStatusLoading: false,

      selectedContactInfoId: 0,
      selectedCustomerName: "",
      selectedMobileNo: "",
      selectedAddress1: "",
      selectedAddress2: "",

      selectedOrderId: 0,
      selectedProductId: 0,
      selectedProductName: "",
      actionTypeId: 0,

      orderItemId: "",
      voucherAmountType: "1",
      voucherPercentage: "",
      voucherAmount: "",
      disputedItemRemarks: "",
      effectiveVoucherFrom: new Date(),
      effectiveVoucherTo: new Date(),
      isOnlineOrder: false,

      isRemoveExtraCopies: 0
    };
  }

  componentDidMount() {
    this.getOrdersData();
    this.getData(
      `/sales/C01SalesOrderStatusView`,
      "statusData",
      "statusDataLoading"
    );
  }

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  getData = async (endpoint = "", stateName = "", loadingStateName = "") => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }

    switch (stateName) {
      case "ordersData":
        console.log("ordersData", stateName);
        this.setState({
          selectedOrder: {},
          imagesData: [],
          selectedSalesData: {},
          salesData: [],
          salesDataItems: [],
        });
        break;
      case "barcodeData":
        if (res.isSuccess && resData.length > 0) {
          localStorage.setItem("ckBarcodeData", JSON.stringify(resData[0]));
          window.open("#/print-barcode");
        }
        break;
      case "salesDataItems":
        console.log("salesDataItems", resData);
        if (res.isSuccess && resData.length > 0) {
          const orderData = resData[0];

          if (!IsEmpty(orderData.products)) {

            // products is the array containing summary
            const productIds = orderData.products.flatMap(order =>
              (order.summary || []).map(item => item.id)
            );


            const paymentMethodId = orderData?.shippingAddresses?.paymentMethodId;
            const isOnlineOrder = paymentMethodId !== 1;
            console.log("paymentMethodId", paymentMethodId);
            console.log("isOnlineOrder", isOnlineOrder);

            this.setState({
              [stateName]: resData,
              [loadingStateName]: false,
              productIds,
              isOnlineOrder,
            });

          } else {
            this.getOrdersData(2);
            this.setState({
              [stateName]: [],
              [loadingStateName]: false,
            });
          }
        }
        break;
      default:
        break;
    }

    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  getOrdersData = async (status = "") => {
    const statusValue = status !== "" ? status : this.state.filterStatus;
    this.getData(
      `/sales/C10SalesOrderView?statusId=${statusValue}`,
      "ordersData",
      "ordersDataLoading"
    );
  };

  getSalesData = async (orderId) => {
    this.getData(
      `/sales/C01SalesOrderItemsViewV2?orderId=${orderId}&statusId=${this.state.filterStatus}`,
      "salesData",
      "salesDataLoading"
    );
  };

  getItemsData = async (orderId, productId) => {
    this.getData(
      `/sales/C10SalesOrderItemsPricingView?orderId=${orderId}&productId=${productId}`,
      "salesDataItems",
      "salesDataItemsLoading"
    );
  };

  getImagesData = async (orderId, productId) => {
    this.getData(
      `/sales/C01SalesOrderItemsImagesViewV2?orderId=${orderId}&productId=${productId}`,
      "imagesData",
      "imagesDataLoading"
    );
  };

  toggleChangeStatusDialog = (typeId, orderId, productId, productName) => {
    const { openChangeStatusDialog } = this.state;
    this.setState({
      openChangeStatusDialog: !openChangeStatusDialog,
      selectedOrderId: orderId,
      selectedProductId: productId,
      selectedProductName: productName,
      actionTypeId: typeId,
    });
  };

  toggleChangeItemQuantityDialog = (orderItem = {}) => {
    const { orderId, id, totalCopies } = orderItem;

    const { openChangeItemQuantityDialog } = this.state;
    this.setState({
      openChangeItemQuantityDialog: !openChangeItemQuantityDialog,
      selectedOrderId: orderId,
      selectedOrderItemId: id,
      selectedQuantity: totalCopies,
      selectedOrderItemForCopies: orderItem,
    });
  };

  toggleChangeContactInfoDialog = (
    id,
    customerName,
    mobileNo,
    address1,
    address2
  ) => {
    const { openChangeContactInfoDialog } = this.state;
    this.setState({
      openChangeContactInfoDialog: !openChangeContactInfoDialog,
      selectedContactInfoId: id,
      selectedCustomerName: customerName,
      selectedMobileNo: mobileNo,
      selectedAddress1: address1,
      selectedAddress2: address2,
    });
  };

  onCheckClick = (e, row = {}) => {
    const { checked } = e.target;
    let { ordersData } = this.state;
    const studentIndex = ordersData.findIndex(
      (item) => item.orderId === row.orderId
    );
    ordersData[studentIndex].isChecked = checked;
    this.setState({
      ordersData,
      selectionDataError: "",
    });
  };

  getOrderId = (order) => {
    console.log("order I am Printed", order);
    //this.getSalesData(order.orderId);
    this.getItemsData(order.orderId);
    this.setState({
      selectedOrder: order,
      imagesData: [],
      selectedSalesData: {},
    });
  };

  getProductDetailAgainstOrderIdAndProductId = (sale, orderId, productId) => {

    this.getItemsData(orderId, productId);
    this.setState({
      selectedSalesData: sale,
    });
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    switch (name) {
      case "filterStatus":
        // this.getOrdersData(value);
        this.setState({
          // salesData: [],
          // salesDataLoading: false,
          // salesDataItems: [],
          // salesDataItemsLoading: false,
          // imagesData: [],
          // imagesDataLoading: false,
          // selectedOrder: {},
          // selectedSalesData: {},
        });
        break;

      default:
        break;
    }
    this.setState({
      [name]: value,
      [errName]: "",
      selectionDataError: "",
    });
  };

  isFormValid = () => {
    let { statusError } = this.state;
    let isValid = true;

    if (!this.state.status) {
      isValid = false;
      statusError = "Please select status";
    } else {
      statusError = "";
    }

    if (this.state.selectedQuantity <= 0) {
      this.handleSnackbar(true, "Quantities can't be less than 1", "error");
      isValid = false;
    } else {
      // Nothing
    }

    this.setState({
      statusError,
    });

    return isValid;
  };

  onSaveClick = () => {
    //debugger;
    if (this.isFormValid()) {
      document.getElementById("btnStatusSubmit").click();
    }
  };

  onFormSubmit = async (e) => {
    //debugger;
    e.preventDefault();
    this.setState({
      isLoading: true,
    });
    const data = new FormData(e.target);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderSaveStatusV2`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved", "success");
      this.setState({
        status: "",
        statusError: "",
        remarks: "",
        remarksError: "",
      });
      this.getData(
        `/sales/C01SalesOrderView?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      isLoading: false,
    });
  };

  onImageClick = (object) => {
    let { imagesData, isNextArrowDisabled, isBackArrowDisabled } = this.state;
    const currentImageIndex = imagesData.findIndex(
      (item) => item.id == object.id
    );

    if (currentImageIndex != -1) {
      if (currentImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      if (currentImageIndex + 1 == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        isNextArrowDisabled = false;
      }
    }

    window.addEventListener(
      "keydown",
      this.handleOnKeyPressedForImageDilog,
      false
    );

    this.setState({
      selectImageObject: object,
      isOpenImageViewer: true,
      selectImageIndex: currentImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleImageViewerToggle = () => {
    const value = this.state.isOpenImageViewer ? false : true;
    this.setState({
      isOpenImageViewer: value,
    });
  };

  downloadFile = async (e, fileName) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${fileName}`;

    let result = await HttpRequestFileDownload(
      "GET",
      url,
      "authorizeJson",
      fileName
    );

    if (result.isSuccess) {
      let csvURL = URL.createObjectURL(result.data);
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", fileName);
      tempLink.click();
    } else {
      if (result.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        alert(result.message);
      }
    }
  };

  handleChangeStatusClose = () => {
    const { openChangeStatusDialog } = this.state;
    this.setState({
      status: "",
      statusError: "",
      remarks: "",
      remarksError: "",
      openChangeStatusDialog: !openChangeStatusDialog,
    });
  };

  handleChangeContactInfoClose = () => {
    const { openChangeContactInfoDialog } = this.state;
    this.setState({
      openChangeContactInfoDialog: !openChangeContactInfoDialog,
    });
  };

  handleChangeItemQuantityClose = () => {
    const { openChangeItemQuantityDialog } = this.state;
    this.setState({
      openChangeItemQuantityDialog: !openChangeItemQuantityDialog,
    });
  };

  onNextArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let nextImageIndex = selectImageIndex;

    if (prevImageIndex != -1) {
      nextImageIndex = prevImageIndex + 1;
      if (nextImageIndex == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        if (nextImageIndex + 1 == imagesData.length) {
          isNextArrowDisabled = true;
        } else {
          isNextArrowDisabled = false;
        }
        isBackArrowDisabled = false;
        imageObject = imagesData[nextImageIndex] || {};
      }
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: nextImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  onBackArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let newImageIndex = selectImageIndex;

    if (prevImageIndex != -1 || prevImageIndex != 0) {
      newImageIndex = prevImageIndex - 1;

      if (newImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      isNextArrowDisabled = false;
      imageObject = imagesData[newImageIndex] || {};
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: newImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleCloseImageDialog = () => {
    window.removeEventListener("keydown", this.handleOnKeyPressedForImageDilog);
    this.setState({
      isOpenImageViewer: false,
      selectImageIndex: 0,
      selectImageObject: {},
      isBackArrowDisabled: true,
      isNextArrowDisabled: true,
    });
  };

  handleOnKeyPressedForImageDilog = (event) => {
    switch (event.key) {
      case "ArrowRight":
        if (!this.state.isNextArrowDisabled) {
          this.onNextArrowClick();
        }
        break;
      case "ArrowLeft":
        if (!this.state.isBackArrowDisabled) {
          this.onBackArrowClick();
        }
        break;
      default:
        break;
    }
  };

  onImagesConfirmationClick = async (statusId) => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const loadingName =
      statusId == 2
        ? "onConfirmItemStatusLoading"
        : "onCancelItemStatusLoading";

    this.setState({
      [loadingName]: true,
    });
    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("statusId", statusId);
    data.append("remarks", this.state.remarks);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsStatusSaveV2`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      let resData = [];
      let selectedSalesData = {};
      const endPoint = `/sales/retrieveSaleOrderProductsPricingList?orderId=${orderId}&statusId=${this.state.filterStatus}`;
      const res2 = await HttpRequest(
        "GET",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endPoint}`,
        null,
        "authorizeJson"
      );
      if (res2.isSuccess) {
        resData = res2.data || [];
        if (resData.length > 0) {
          selectedSalesData = resData.find((item) => item.id == orderItemId);
        }
        this.setState({
          salesData: resData,
          selectedSalesData,
        });
      } else {
        if (res2.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
          });
        } else {
          // this.handleSnackbar(true, res2.message, "error");
        }
      }
      this.getData(
        `/sales/C01SalesOrderView?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      const { openChangeStatusDialog } = this.state;
      this.setState({
        remarks: "",
        remarksError: "",
        openChangeStatusDialog: !openChangeStatusDialog,
      });
      this.handleSnackbar(true, "Updated", "success");
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  // onSaveClick = () => {
  //   if (this.isFormValid()) {
  //     document.getElementById("btnStatusSubmit").click();
  //   }
  // };
  valitateContactInfo = () => {
    if (this.state.selectedCustomerName == "") {
      return false;
    } else if (this.state.selectedMobileNo == "") {
      return false;
    } else if (this.state.selectedAddress1 == "") {
      return false;
    } else if (this.state.selectedAddress2 == "") {
      return false;
    }
    return true;
  };

  onContactInfoClickAction = async () => {
    this.setState({
      onDoneItemStatusLoading: true,
    });

    if (this.valitateContactInfo()) {
      const data = new FormData();

      data.append("id", this.state.selectedContactInfoId);
      data.append("customerName", this.state.selectedCustomerName);
      data.append("mobileNo", this.state.selectedMobileNo);
      data.append("address1", this.state.selectedAddress1);
      data.append("address2", this.state.selectedAddress2);

      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C10CommonUsersShippingAddressesUpdate`,
        data,
        "authorize"
      );

      if (res.isSuccess) {
        const { openChangeContactInfoDialog } = this.state;

        this.setState({
          selectedContactInfoId: 0,
          selectedAddress1: "",
          selectedAddress2: "",
          selectedCustomerName: "",
          selectedMobileNo: "",
          customerNameError: "",
          address1Error: "",
          address2Error: "",
          mobileError: "",
          openChangeContactInfoDialog: !openChangeContactInfoDialog,
          salesDataItems: [],
        });

        this.handleSnackbar(true, "Updated", "success");

        // this.getOrdersData(2);
      } else {
        if (res.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          this.handleSnackbar(true, res.message, "error");
        }
      }
    } else {
      alert("Please enter all fields");
    }

    this.setState({
      onDoneItemStatusLoading: false,
    });
  };

  isOrderConfirmationFormValid = () => {
    let { remarksError } = this.state;
    let isValid = true;

    if (!this.state.remarks) {
      isValid = false;
      remarksError = "Please enter remarks";
    } else {
      const trimRemarks = this.state.remarks.trim();
      if (!trimRemarks) {
        isValid = false;
        remarksError = "Please enter valid remarks";
        this.setState({
          remarks: trimRemarks,
        });
      }
    }

    this.setState({
      remarksError,
    });

    return isValid;
  };

  onClickAction = async () => {
    if (!this.isOrderConfirmationFormValid()) {
      return;
    }

    this.setState({ onDoneItemStatusLoading: true });

    const data = new FormData();
    const actionTypeId = this.state.actionTypeId; // cache for cleaner code

    if (actionTypeId === 1) {
      data.append("statusId", 13);
      data.append("orderId", this.state.selectedOrderId);
      data.append("productRecordId", this.state.selectedProductId);
      data.append("remarks", this.state.remarks);

    } else if (actionTypeId === 2) {
      data.append("statusId", 6);
      data.append("orderId", this.state.selectedOrderId);
      data.append("productRecordId", this.state.selectedProductId);
      data.append("remarks", this.state.remarks);

    } else if (actionTypeId === 3) {
      data.append("statusId", 13);
      data.append("orderId", this.state.selectedOrderId);
      this.state.productIds.forEach(product =>   // ✅ forEach not map
        data.append("productRecordId", product)
      );
      data.append("remarks", this.state.remarks);

    } else if (actionTypeId === 4) {
      data.append("statusId", 6);
      data.append("orderId", this.state.selectedOrderId);
      this.state.productIds.forEach(product =>   // ✅ forEach not map
        data.append("productRecordId", product)
      );
      data.append("remarks", this.state.remarks);
    }

    let res = null; // ✅ let instead of const

    try {
      const isMultiProduct = actionTypeId === 3 || actionTypeId === 4;
      const endpoint = isMultiProduct
        ? "sales/C10SalesOrderItemStatusAllProductsSave"
        : "sales/C10SalesOrderItemStatusSave";

      res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/${endpoint}`,
        data,
        "authorize"
      );
    } catch (error) {
      console.error("HttpRequest failed:", error);
      this.handleSnackbar(true, "Something went wrong. Please try again.", "error");
      this.setState({ onDoneItemStatusLoading: false });
      return;
    }

    if (res && res.isSuccess) { // ✅ null check added
      const { openChangeStatusDialog } = this.state;
      this.setState({
        remarks: "",
        remarksError: "",
        openChangeStatusDialog: !openChangeStatusDialog,
        salesDataItems: [],
      });

      const message = actionTypeId === 1 || actionTypeId === 3
        ? "Sent to Supervisor Dashboard, Confirmed tab."
        : "Sent to Supervisor Dashboard, Cancelled tab.";

      this.handleSnackbar(true, message, "success");

      this.getItemsData(
        this.state.selectedOrderId,
        this.state.selectedProductId
      );

    } else if (res) {
      if (res.statusCode === 401) {
        this.setState({ isLoginMenu: true, isReload: false });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }

    this.setState({ onDoneItemStatusLoading: false });
  };

  // onClickAction = async () => {
  //   if (!this.isOrderConfirmationFormValid()) {
  //     return;
  //   }

  //   this.setState({
  //     onDoneItemStatusLoading: true,
  //   });

  //   const data = new FormData();
  //   if (this.state.actionTypeId === 1) {
  //     data.append("statusId", 13); // Confirmed
  //     data.append("orderId", this.state.selectedOrderId);
  //     data.append("productRecordId", this.state.selectedProductId);
  //     data.append("remarks", this.state.remarks);
  //   } else if (this.state.actionTypeId === 2) {
  //     data.append("statusId", 6); // Cancelled
  //     data.append("orderId", this.state.selectedOrderId);
  //     data.append("productRecordId", this.state.selectedProductId);
  //     data.append("remarks", this.state.remarks);
  //   } else if (this.state.actionTypeId === 3) {

  //     data.append("statusId", 13); // Confirmed
  //     data.append("orderId", this.state.selectedOrderId);
  //     this.state.productIds.forEach(product =>

  //       data.append("productRecordId", product)
  //     );

  //     data.append("remarks", this.state.remarks);
  //   } else if (this.state.actionTypeId === 4) {
  //     data.append("statusId", 6); // ALL Cancelled
  //     data.append("orderId", this.state.selectedOrderId);

  //     this.state.productIds.forEach(product =>

  //       data.append("productRecordId", product)
  //     );
  //     data.append("remarks", this.state.remarks);
  //   }
  //   const res = null;


  //   if (this.state.actionTypeId === 3 || this.state.actionTypeId === 4) {
  //     res = await HttpRequest(
  //       "POST",
  //       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C10SalesOrderItemStatusAllProductsSave`,
  //       data,
  //       "authorize"
  //     );
  //   } else {
  //     res = await HttpRequest(
  //       "POST",
  //       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C10SalesOrderItemStatusSave`,
  //       data,
  //       "authorize"
  //     );
  //   }



  //   if (res.isSuccess) {
  //     const { openChangeStatusDialog } = this.state;
  //     this.setState({
  //       remarks: "",
  //       remarksError: "",
  //       openChangeStatusDialog: !openChangeStatusDialog,
  //       salesDataItems: [],
  //     });
  //     if (this.state.actionTypeId == 1) {
  //       this.handleSnackbar(
  //         true,
  //         "Sent to Supervisor Dashboard, Confirmed tab.",
  //         "success"
  //       );
  //     } else {
  //       this.handleSnackbar(
  //         true,
  //         "Sent to Supervisor Dashboard, Cancelled tab.",
  //         "success"
  //       );
  //     }
  //     this.getItemsData(
  //       this.state.selectedOrderId,
  //       this.state.selectedProductId
  //     );
  //     //this.getOrdersData(2);
  //   } else {
  //     if (res.statusCode === 401) {
  //       this.setState({
  //         isLoginMenu: true,
  //         isReload: false,
  //       });
  //     } else {
  //       this.handleSnackbar(true, res.message, "error");
  //     }
  //   }
  //   this.setState({
  //     onDoneItemStatusLoading: false,
  //   });
  // };

  onItemQuantityClickAction = async () => {
    this.setState({
      onDoneItemStatusLoading: true,
    });

    const data = new FormData();

    data.append(
      "quantity",
      this.state.isRemoveExtraCopies == 1 ? 0 : this.state.selectedQuantity
    );
    data.append("saleOrderId", this.state.selectedOrderId);
    data.append("orderItemId", this.state.selectedOrderItemId);

    if (
      this.state.isRemoveExtraCopies == 1 ||
      (this.state.isRemoveExtraCopies != 1 && this.state.selectedQuantity > 0)
    ) {
      const res = await HttpRequest(
        "POST",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C10SaleOrderItemsChangeQuantityV2`,
        data,
        "authorize"
      );

      if (res.isSuccess) {
        const { openChangeItemQuantityDialog } = this.state;
        this.getItemsData(
          this.state.selectedOrderId,
          this.state.selectedOrderItemId
        );
        this.setState({
          selectedQuantity: 0,
          quantityError: "",
          // selectedOrderId: 0,
          openChangeItemQuantityDialog: !openChangeItemQuantityDialog,
          salesDataItems: [],
        });

        this.handleSnackbar(true, "Updated", "success");
      } else {
        if (res.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          this.handleSnackbar(true, res.message, "error");
        }
      }
    } else {
      this.handleSnackbar(true, "Copies can't be less than 0", "error");
    }
    this.setState({
      onDoneItemStatusLoading: false,
    });
  };

  toggleChangeDisputedStatusDialog = (actionTypeId, orderItemId) => {
    const { openChangeStatusDisputedDialog } = this.state;
    this.setState({
      openChangeStatusDisputedDialog: !openChangeStatusDisputedDialog,
      actionTypeId: actionTypeId,
      orderItemId: orderItemId,
    });
  };

  handleChangeDisputedStatusClose = () => {
    const { openChangeStatusDisputedDialog } = this.state;
    this.setState({
      openChangeStatusDisputedDialog: !openChangeStatusDisputedDialog,
    });
  };

  onConfirmClick = async () => {
    this.setState({
      onDoneItemStatusLoading: true,
    });

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const data = new FormData();

    data.append("statusId", 13);
    data.append("orderId", orderId);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C10SalesOrderStatusSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Updated", "success");
      this.getOrdersData(2);
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      onDoneItemStatusLoading: false,
    });
  };

  setEffectiveFrom = async (e) => {
    let date = e.target.value;
    const arr = date.split("-");
    const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    await this.setState({
      effectiveVoucherFrom: formattedDate,
    });
  };

  setEffectiveTo = async (e) => {
    let date = e.target.value;
    const arr = date.split("-");
    const formattedDate = `${arr[2]}-${arr[1]}-${arr[0]}`;
    await this.setState({
      effectiveVoucherTo: formattedDate,
    });
  };

  changeStatusDisputedOrder = async (actionId, orderItemId) => {
    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const disputeId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.disputeId;

    const remarks = IsEmpty(this.state.disputedItemRemarks)
      ? ""
      : this.state.disputedItemRemarks;

    const voucherAmountType = this.state.voucherAmountType;
    const voucherPercentage = this.state.voucherPercentage;
    const voucherAmount = this.state.voucherAmount;
    const effectiveFrom = this.state.effectiveVoucherFrom;
    const effectiveTo = this.state.effectiveVoucherTo;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("disputeId", disputeId);

    data.append("statusId", actionId);
    data.append("remarks", remarks);

    if (actionId == 100) {
      data.append("isPercentage", voucherAmountType);
      data.append("voucherAmount", voucherAmount === "" ? 0 : voucherAmount);
      data.append(
        "voucherPercentage",
        voucherPercentage === "" ? 0 : voucherPercentage
      );

      data.append("effectiveFrom", effectiveFrom);
      data.append("effectiveTo", effectiveTo);
    }

    const loadingName = "changeDisputeLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C10SalesOrderDisputedItemsSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.getItemsData(orderId, this.state.selectedProductId);

      if (actionId == 10) {
        this.handleSnackbar(true, "Accepted", "success");
      } else if (actionId == 0) {
        this.handleSnackbar(true, "Rejected", "success");
      } else if (actionId == 100) {
        this.handleSnackbar(true, "Resolved", "success");
      }

      this.setState({
        disputedItemRemarks: "",
        voucherAmountType: "1",
        voucherPercentage: "",
        voucherAmount: "",
        effectiveVoucherFrom: "",
        effectiveVoucherTo: "",
      });
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.handleChangeDisputedStatusClose();
    this.setState({
      [loadingName]: false,
    });
  };

  setVoucherAmountType = async (e) => {
    await this.setState({
      voucherAmountType: e.target.value,
    });
  };

  render() {
    const { classes } = this.props;
    let screenHeight = (window.screen.height * 72) / 100;
    return (
      <Fragment>
        <NavBar isAuthorize title="Order Confirmation Dashboard" />
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <form onSubmit={this.onFormSubmit}>
          <input name="statusId" value={this.state.status} type="hidden" />
          <input
            name="orderId"
            value={
              IsEmpty(this.state.selectedOrder)
                ? 0
                : this.state.selectedOrder.orderId
            }
            type="hidden"
          />
          <input name="remarks" value={this.state.remarks} type="hidden" />
          <input
            type="submit"
            style={{ display: "none" }}
            id="btnStatusSubmit"
          />
        </form>

        <ChangeStatusV2
          onSaveClick={() => this.onClickAction()}
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openChangeStatusDialog}
          state={this.state}
          handleClose={() => this.handleChangeStatusClose()}
        />
        <ChangeContactInfo
          onSaveClick={() => this.onContactInfoClickAction()}
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openChangeContactInfoDialog}
          state={this.state}
          handleClose={() => this.handleChangeContactInfoClose()}
        />

        <ChangeItemQuantity
          onSaveClick={() => this.onItemQuantityClickAction()}
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openChangeItemQuantityDialog}
          state={this.state}
          handleClose={() => this.handleChangeItemQuantityClose()}
        />

        <ChangeStatusDispute
          onSaveClick={(actionId, orderItemId) =>
            this.changeStatusDisputedOrder(actionId, orderItemId)
          }
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openChangeStatusDisputedDialog}
          state={this.state}
          handleClose={() => this.handleChangeDisputedStatusClose()}
          setVoucherAmountType={(e) => this.setVoucherAmountType(e)}
          setEffectiveTo={this.setEffectiveTo}
          setEffectiveFrom={this.setEffectiveFrom}
        />

        <div style={{ height: screenHeight }} className={classes.tabsContainer}>
          <div className={classes.contentContainerS}>
            <OrderTabV2
              onHandleChange={this.onHandleChange}
              values={this.state}
              getOrderId={(id) => this.getOrderId(id)}
            />
          </div>

          <div className={classes.contentContainerSM}>
            {this.state.isOnlineOrder ?

              <SalesTabForOnline
                selectedOrder={this.state.salesDataItems}
                values={this.state}
                onClickAction={() => this.onClickAction()}
                toggleChangeContactInfoDialog={(
                  id,
                  customerName,
                  mobileNo,
                  address1,
                  address2
                ) =>
                  this.toggleChangeContactInfoDialog(
                    id,
                    customerName,
                    mobileNo,
                    address1,
                    address2
                  )
                }
                toggleChangeItemQuantityDialog={(orderId, itemId, quantity) =>
                  this.toggleChangeItemQuantityDialog(orderId, itemId, quantity)
                }
                toggleChangeStatusDialog={(
                  actionTypeId,
                  orderId,
                  productId,
                  productName
                ) =>
                  this.toggleChangeStatusDialog(
                    actionTypeId,
                    orderId,
                    productId,
                    productName
                  )
                }
                toggleChangeDisputedStatusDialog={(actionId, orderItemId) =>
                  this.toggleChangeDisputedStatusDialog(actionId, orderItemId)
                }
              />

              :
              <SalesTabV4
                selectedOrder={this.state.salesDataItems}
                values={this.state}
                onClickAction={() => this.onClickAction()}
                toggleChangeContactInfoDialog={(
                  id,
                  customerName,
                  mobileNo,
                  address1,
                  address2
                ) =>
                  this.toggleChangeContactInfoDialog(
                    id,
                    customerName,
                    mobileNo,
                    address1,
                    address2
                  )
                }
                toggleChangeItemQuantityDialog={(orderId, itemId, quantity) =>
                  this.toggleChangeItemQuantityDialog(orderId, itemId, quantity)
                }
                toggleChangeStatusDialog={(
                  actionTypeId,
                  orderId,
                  productId,
                  productName
                ) =>
                  this.toggleChangeStatusDialog(
                    actionTypeId,
                    orderId,
                    productId,
                    productName
                  )
                }
                toggleChangeDisputedStatusDialog={(actionId, orderItemId) =>
                  this.toggleChangeDisputedStatusDialog(actionId, orderItemId)
                }
              />
            }

          </div>
        </div>

        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
      </Fragment>
    );
  }
}

C10OrderConfirmationDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C10OrderConfirmationDashboard);
